'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$$anon$1() {
}
export { $c_Lmagnolia1_CaseClassDerivation$$anon$1 as $c_Lmagnolia1_CaseClassDerivation$$anon$1 };
$p = $c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CaseClassDerivation$$anon$1;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$$anon$1() {
}
export { $h_Lmagnolia1_CaseClassDerivation$$anon$1 as $h_Lmagnolia1_CaseClassDerivation$$anon$1 };
$h_Lmagnolia1_CaseClassDerivation$$anon$1.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_None$();
});
var $d_Lmagnolia1_CaseClassDerivation$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CaseClassDerivation$$anon$1, "magnolia1.CaseClassDerivation$$anon$1", ({
  nP: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$$anon$1 as $d_Lmagnolia1_CaseClassDerivation$$anon$1 };
